import React, { useState } from "react";
import { Button, Tabs, message } from "antd";
import { NextButton, PreviousButton } from "@comps/components";
import IndexLeaveTypes from "@mods/leaveManagement/settings/leaveType/IndexLeaveTypes";
import IndexQuotaAdjusts from "@mods/leaveManagement/quotaAdjustment/IndexQuotaAdjust";
import ReadinessSummary from "./ReadinessSummary";

// Step 5 — Leave Assignments. Reuses the real leave-module screens:
//   • Manage Leave Types -> IndexLeaveTypes (create/view/update/delete; its own
//     "Assign to employees" button drives the pick types -> employees -> preview
//     -> save flow that allots quotas)
//   • Quota Adjustment   -> IndexQuotaAdjusts (adjust an existing employee quota)
// Optional/skippable step: Continue is always enabled.

const StepLeaveAssignments = (props) => {
  const { onNext, onBack, readiness, readinessLoading, refreshReadiness, statuses, skipStep, clearSkip } = props;
  const [activeTab, setActiveTab] = useState("types");

  const continueStep = () => {
    clearSkip?.("leave");
    refreshReadiness?.();
    onNext();
  };

  const skip = () => {
    skipStep?.("leave");
    message.info("Leave setup skipped for now.");
    onNext();
  };

  const items = [
    {
      key: "types",
      label: "Manage Leave Types",
      children: (
        <div className="onb-embed">
          <div className="onb-card-sub">
            Define the leave types your company offers (annual, sick, casual, …) — create, view and edit them.
            Use <b>Assign to employees</b> to grant a type to your team and allot their quota.
          </div>
          <IndexLeaveTypes modkey="leaveTypes" />
        </div>
      ),
    },
    {
      key: "adjust",
      label: "Quota Adjustment",
      children: (
        <div className="onb-embed">
          <div className="onb-card-sub">
            Fine-tune an individual employee's leave balance — adjust quota, availed or carry-forward days.
          </div>
          <IndexQuotaAdjusts modkey="leaveQuotaAdjustment" />
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="onb-card-title">Leave assignments</div>
      <div className="onb-card-sub">
        Optional: set up leave types and quotas now, or skip and configure them later from Leave Management.
      </div>

      <ReadinessSummary
        status={statuses.leave}
        loading={readinessLoading}
        onRefresh={refreshReadiness}
        items={[
          { label: "Leave types", value: readiness.leave.count || 0 },
          { label: "Quota records", value: readiness.leave.quotaCount || 0 },
          { label: "Quota setup", value: (readiness.leave.quotaCount || 0) > 0 ? "Configured" : "Not assigned" },
        ]}
      />

      {(readiness.leave.count || 0) < 1 ? (
        <div className="onb-empty-guidance">No leave types found. You can configure them now or skip for later.</div>
      ) : (readiness.leave.quotaCount || 0) < 1 ? (
        <div className="onb-empty-guidance">Leave types exist. Assign them to employees when you are ready to create quota records.</div>
      ) : null}

      <Tabs
        className="onb-tabs"
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
      />

      <div className="onb-foot">
        <PreviousButton onClick={onBack} text="Back" />
        <span className="spacer" />
        <Button onClick={skip}>Skip for now</Button>
        <NextButton onClick={continueStep} text="Continue" />
      </div>
    </>
  );
};

export default StepLeaveAssignments;
